export enum ReportType {
	EXTENDED = 'extended',
	SMALL = 'small',
	UNBLOCKREQUESTS = 'unblockRequests',
	DZO_ORDERS = 'dzo_orders',
}

export interface ReportOption {
	label: string
	value: ReportType
	key: ReportType
	description: string
}

export const reportOptions: ReportOption[] = [
	{
		label: 'Стандартный отчёт',
		value: ReportType.SMALL,
		key: ReportType.SMALL,
		description: 'Сводная информация по заявкам с базовым набором данных',
	},
	{
		label: 'Расширенный отчёт',
		value: ReportType.EXTENDED,
		key: ReportType.EXTENDED,
		description: 'Сводная информация по заявкам с расширенным набором данных',
	},
	{
		label: 'Отчет для КЭС',
		value: ReportType.DZO_ORDERS,
		key: ReportType.DZO_ORDERS,
		description: '',
	},
]
